import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
export function NumberInput({ id, label, value, onChange, min = 0, max = 1000000, prefix, placeholder = 'Digite um valor', className = 'brutal-input', }) {
    const handleChange = useCallback((e) => {
        const v = parseFloat(e.target.value);
        onChange(isNaN(v) ? 0 : v);
    }, [onChange]);
    const labelStyle = {
        fontSize: '0.75rem',
        fontWeight: '600',
        color: '#999999',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        marginBottom: '0.375rem',
        display: 'block',
    };
    const inputStyle = {
        width: '100%',
        maxWidth: '320px',
        backgroundColor: '#141414',
        border: '2px solid #333333',
        borderRadius: 0,
        color: '#f5f5f5',
        padding: prefix ? '10px 14px 10px 42px' : '10px 14px',
        fontFamily: 'inherit',
        fontSize: '13px',
        lineHeight: '1.4',
        transition: 'border-color 0.15s ease',
        boxSizing: 'border-box',
    };
    const prefixStyle = {
        position: 'absolute',
        left: '14px',
        top: '50%',
        transform: 'translateY(-50%)',
        color: '#666666',
        pointerEvents: 'none',
        fontSize: '13px',
    };
    return (_jsxs("div", { style: { display: 'flex', flexDirection: 'column', gap: '0.375rem', maxWidth: '320px' }, children: [_jsx("label", { htmlFor: id, style: labelStyle, children: label }), _jsxs("div", { style: { position: 'relative' }, children: [prefix && _jsx("span", { style: prefixStyle, children: prefix }), _jsx("input", { id: id, type: "number", min: min, max: max, value: value === 0 ? '' : value, onChange: handleChange, placeholder: placeholder, style: inputStyle })] })] }));
}
